export default __webpack_public_path__ + "static/media/Third View.f70f83a3.jpg";